<template>
<div class="main__body" v-loading="!isReady">
  <Layout></Layout>
  <!-- 引入访客邀请弹框 -->
  <add-invite v-if="addInvShow" @addInvChange="addInvClose" :singlevistiorInfo="singlevistiorInfo"
              :sourceInviteInfo="sourceInviteInfo" :childTitle="childTitle"></add-invite>
  <router-view v-if="isReady&&!isShiftedProject" class="main__middle"
               v-loading="$store.getters.isRouterLoading"></router-view>
  <div class="shift-info-container" v-else-if="isShiftedProject">
    此项目已经迁移至 <a :href="shiftInfo.newUrl" target="_blank">{{shiftInfo.newUrl}}</a>
  </div>
  <announcement-bar></announcement-bar>
  <notification-panel v-if="isNotificationActivated" :class="{showed:$store.getters.notification.isPanelShow}"
                      @closeButtonClicked="$store.getters.notification.isPanelShow=false"></notification-panel>
  <confirm />
</div>
</template>
<script>
import Layout from './components/layout/layout.vue'
import AnnouncementBar from './components/announcementBar'
import NotificationPanel from './components/notification/notificationPanel'
import addInvite from './pages/personManage/common/addInvite.vue'
import cookie from './utils/Tools/index'
import confirm from './components/public/confirmDialog.vue'
import axios from 'axios'

export default {
  components: {
    Layout,
    AnnouncementBar,
    NotificationPanel,
    addInvite,
    confirm
  },
  data () {
    return {
      addInvShow: false,
      singlevistiorInfo: {
        btnStatus: '',
        visitorType: 2,
        id: ''
      },
      sourceInviteInfo: {},
      childTitle: '',
      shiftInfo: null,
      isNotificationActivated: !!this.$store.getters.user.isAdmin
    }
  },
  computed: {
    isReady () {
      return (this.$store.getters.user.isAdmin || this.$store.getters.user.selectedProject) && this.shiftInfo
    },
    isShiftedProject () {
      const selectedProject = this.$store.getters.user.selectedProject
      return selectedProject && this.$route.name !== 'refresh' && this.shiftInfo && this.shiftInfo.shiftProjectIdList.find(id => id === selectedProject.id)
      // if (selectedProject && this.$route.name !== 'refresh' && this.shiftInfo && this.shiftInfo.shiftProjectIdList.find(id => id === selectedProject.id)) {
      //   return true
      // }
      // return false
    }
  },
  methods: {
    addInvClose () {
      this.addInvShow = false
    },
    // async getShiftInfo () {
    //   const responseData = await axios({
    //     method: 'get',
    //     url: window.location.origin + '/static/shiftInfo.json'
    //   })
    //   this.shiftInfo = responseData.data
    // }
    getShiftInfo () {
      this.shiftInfo = JSON.parse(JSON.stringify(window.DATA.shiftInfo))
    }
  },
  watch: {
    '$store.getters.user.selectedProject' (val) {
      if (val) {
        this.isNotificationActivated = false
        this.$nextTick(() => {
          this.isNotificationActivated = true
        })
      }
    }
  },
  created () {
    this.getShiftInfo()
  },
  mounted () {
    var that = this
    var menu = this.$store.getters.menuList
    var filer = menu.filter(o => o.menuText.indexOf('人员') > -1)
    var filerMenu = []
    if (filer.length > 0) {
      filerMenu = filer[0].sub_menu.filter(o => o.menuText.indexOf('访客') > -1)
    }
    if (filerMenu.length > 0) {
      // 初始化一个 WebSocket 对象
      var url = `${axios.defaults.baseURL}/wxdjcheck/${sessionStorage.getItem('UserId')}`
      var ws = new WebSocket(url.replace('http', 'ws'))
      // 建立 web socket 连接成功触发事件
      ws.onopen = function () {

      }
      // 接收服务端数据时触发事件
      ws.onmessage = function (evt) {
        var data = JSON.parse(evt.data)
        that.$notify({
          title: '提示',
          message: `您有一条待审核的自助登记数据(${data.VisitorName})，请点击进行审核`,
          duration: 0,
          onClick: function () {
            that.$https.get('/visitor/getById', { visitorRecordId: data.id }).then(res => {
              that.addInvShow = false
              this.$nextTick(o => {
                that.addInvShow = true
                that.childTitle = '自助登记'
                res.data.leaveTime = cookie.dateFormat(res.data.leaveTime, 'yyyy-MM-dd hh:mm')
                res.data.fromTime = cookie.dateFormat(res.data.fromTime, 'yyyy-MM-dd hh:mm')
                that.singlevistiorInfo = res.data
              })
            })
          }
        })
      }
    }
  }
}
</script>
<style lang="less">
@spaceName: main;
.@{spaceName} {
  &__middle {
    width: 100%;
    // position: relative;
    padding-right: 9px;
    padding-left: 9px;
    padding-bottom: 9px;
    background-color: #e1e8f2;
    height: 100%;
    overflow: auto;
    z-index: 9;
  }
  &__body {
    position: relative;
    width: 100%;
    height: 100%;
    padding-bottom: 80px;
    overflow: hidden;
    // min-width: 1120px;
    min-width: 1280px;
    > .shift-info-container {
      margin-top: 80px;
      text-align: center;
      font-size: 22px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/main.vue